import PropTypes from "prop-types";
import React from 'react'


const SEO = ( {title} ) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title>N01ZET Academy</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="N01ZET - Le partage est la valeur - Sharing Value Platform" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;


